import { CurrentUsers } from '@/components/CurrentUsers/CurrentUsers';
import { useProgramPresence } from '@/providers/websocket';

type ProgramBroadcastReviewersProps = {
  programBroadcastId: string;
};

/**
 * Reviewers currently working on a programme of the schedule list.
 *
 * Presence is subscribed to here, in a leaf of a single cell, and deliberately
 * not in `BroadcastScheduleTable`: a subscription up there re-renders the whole
 * table on every occupancy change, and the design system's date-range picker
 * discards a selection the user has not applied yet whenever the table around it
 * re-renders. The `data-reviewer-occupied` marker lets the row pick up its
 * highlight from CSS (`.reviewer-occupied-row:has(...)` in `index.css`) without
 * the table having to know about presence at all.
 */
export function ProgramBroadcastReviewers({ programBroadcastId }: ProgramBroadcastReviewersProps) {
  const reviewers = useProgramPresence()[programBroadcastId];

  if (!reviewers?.length) return null;

  return (
    <span className="flex items-center" data-reviewer-occupied="">
      <CurrentUsers ids={reviewers} />
    </span>
  );
}
